import React from "react";
import { string } from "prop-types";

const RightArrowButton = ({
  color = "#FFFFFF",
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.047 65.61" width="60" height="60">
    <filter height="130%" id="dropshadow">
      <feGaussianBlur in="SourceAlpha" stdDeviation="3"></feGaussianBlur>
      <feOffset dx="1" dy="1" result="offsetblur"></feOffset>
      <feComponentTransfer>
        <feFuncA slope="0.8" type="linear"></feFuncA>
      </feComponentTransfer>
      <feMerge>
        <feMergeNode></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <g filter="url(#dropshadow)">
      <path
        fill={color}
        d="M17.7,3.9c0.7,0,1.4,0.3,1.9,0.8L45,30L19.7,55.3c-1.1,1.1-2.8,1.1-3.9,0s-1.1-2.8,0-3.9L37.2,30L15.8,8.6
c-1.1-1.1-1.1-2.8,0-3.9C16.3,4.1,17,3.9,17.7,3.9z"
      />
    </g>
  </svg>
);

RightArrowButton.propTypes = {
  color: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default RightArrowButton;
